import { Nullable } from 'modules/types/common';
import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';

export interface HealthAdvisory {
  snooze: {
    isFetching: boolean;
    error: Nullable<Error>;
    isComplete: boolean;
    message: Nullable<string>;
  };
}

const healthAdvisoryInitialState = (): HealthAdvisory => ({
  snooze: {
    isFetching: false,
    error: null,
    isComplete: false,
    message: null
  }
});

const healthAdvisory = createReducer(healthAdvisoryInitialState(), {
  [actions.SNOOZE_HEALTH_ADVISORY_CARD_FAIL]: (state, action) => {
    state.snooze.isFetching = false;
    state.snooze.error = action.error;
    state.snooze.message = action.error;
  },
  [actions.SNOOZE_HEALTH_ADVISORY_CARD_SUCCESS]: state => {
    state.snooze.isFetching = false;
    state.snooze.isComplete = true;
  },
  [actions.SNOOZE_HEALTH_ADVISORY_CARD_RESET]: state => {
    state.snooze.isComplete = false;
  }
});

export default healthAdvisory;
